import { useQuery } from "react-query";
import { FeatureResource, featureGet } from "../../api/vehicleFeatures";

export const orderRequirementsKey = (workspaceId: string, orderId: string) =>
  ["order-vehicle-requirements", workspaceId, orderId] as const;

export function useOrderRequirements(workspaceId: string, orderId: string) {
  return useQuery(
    orderRequirementsKey(workspaceId, orderId),
    () => featureGet<FeatureResource>(workspaceId, `order/${orderId}`),
    {
      enabled: Boolean(workspaceId && orderId),
      retry: false,
      staleTime: 0,
      cacheTime: 0,
    },
  );
}
